import { SubmenuItem } from "../types/header.interface"

export const resolveCurrentPageMenuPathFor = (
  menuItems: SubmenuItem[],
  pathname: string
) => {
  let to: string | null = null
  menuItems.map(({ path }) => {
    if (!to) {
      to = pathname === `${path}/` ? path : null
    }
  })
  return to
}
